import { useThemeSlice } from "../../../components/ui/StatusBadge.jsx";
import { Ico } from "../../../components/icons/icons.jsx";
import { ASSET_COLUMN_TYPES } from "../assetTypeUtils.js";

export function AssetTypeColumnEditor({
  columns,
  errors = [],
  onChange,
  sectionTitle = "Columns",
  entityLabel = "asset type",
}) {
  const { c } = useThemeSlice();

  const addColumn = () => {
    onChange([...columns, { key: "", type: "string" }]);
  };

  const updateColumn = (index, patch) => {
    onChange(columns.map((col, i) => (i === index ? { ...col, ...patch } : col)));
  };

  const removeColumn = (index) => {
    onChange(columns.filter((_, i) => i !== index));
  };

  return (
    <div style={{ marginBottom: 18 }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
        <span style={{ fontSize: 11, fontWeight: 700, color: c.sub, textTransform: "uppercase", letterSpacing: "0.04em" }}>
          {sectionTitle}
        </span>
        <button type="button" onClick={addColumn} style={addBtn(c)}>
          {Ico.plus}
          Add column
        </button>
      </div>

      {columns.length === 0 ? (
        <p style={{ margin: 0, fontSize: 12, color: c.sub, padding: "12px 14px", borderRadius: 8, border: `1px dashed ${c.cardBdr}`, background: c.hover }}>
          No columns yet. Click <strong>Add column</strong> to define fields for this {entityLabel}.
        </p>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 120px 32px", gap: 8, padding: "0 2px" }}>
            <span style={headerLabel(c)}>Key</span>
            <span style={headerLabel(c)}>Type</span>
            <span />
          </div>
          {columns.map((col, index) => (
            <div key={index} style={{ display: "grid", gridTemplateColumns: "1fr 120px 32px", gap: 8, alignItems: "start" }}>
              <input
                type="text"
                value={col.key}
                placeholder="e.g. registration"
                onChange={(e) => updateColumn(index, { key: e.target.value })}
                style={inputStyle(c, errors[index]?.key)}
              />
              <select
                value={col.type}
                onChange={(e) => updateColumn(index, { type: e.target.value })}
                style={selectStyle(c, errors[index]?.type)}
              >
                {ASSET_COLUMN_TYPES.map((type) => (
                  <option key={type} value={type}>{type}</option>
                ))}
              </select>
              <button type="button" aria-label="Remove column" onClick={() => removeColumn(index)} style={removeBtn(c)}>
                {Ico.x}
              </button>
              {(errors[index]?.key || errors[index]?.type) && (
                <div style={{ gridColumn: "1 / -1", fontSize: 11, color: "#EF4444", fontWeight: 600, marginTop: -4 }}>
                  {errors[index]?.key || errors[index]?.type}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function headerLabel(c) {
  return { fontSize: 10, fontWeight: 700, color: c.sub, textTransform: "uppercase", letterSpacing: "0.05em" };
}

function inputStyle(c, hasError) {
  return {
    width: "100%",
    height: 36,
    padding: "0 10px",
    borderRadius: 8,
    border: `1px solid ${hasError ? "#EF4444" : c.cardBdr}`,
    background: c.card,
    color: c.text,
    fontSize: 13,
    outline: "none",
    boxSizing: "border-box",
    fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
  };
}

function selectStyle(c, hasError) {
  return {
    ...inputStyle(c, hasError),
    fontFamily: "inherit",
    cursor: "pointer",
  };
}

function addBtn(c) {
  return {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    height: 30,
    padding: "0 10px",
    borderRadius: 8,
    border: `1px solid ${c.cardBdr}`,
    background: c.card,
    color: c.text,
    fontSize: 11,
    fontWeight: 700,
    cursor: "pointer",
  };
}

function removeBtn(c) {
  return {
    width: 32,
    height: 36,
    borderRadius: 8,
    border: `1px solid ${c.cardBdr}`,
    background: c.card,
    color: c.sub,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };
}
